var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data)?[_c('div',{staticClass:"nj-flx g12"},[_c('Fecha',{attrs:{"data":_vm.data}}),_c('Hora',{attrs:{"data":_vm.data}})],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }